import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { PrefsProvider } from './contexts/PrefsContext';
import { PlayProvider } from './contexts/PlayContext';
import { ModalProvider } from './contexts/ModalContext';
import reportWebVitals from './reportWebVitals';

// Auth outermost: both Prefs and Play watch the identity and reload when it
// changes (sign in, sign out, or a guest record coming into existence).
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PrefsProvider>
          <PlayProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </PlayProvider>
        </PrefsProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
